export const UPDATE_COMMUNITY = 'UPDATE_COMMUNITY'
export const UPDATE_SUBDIVISION = 'UPDATE_SUBDIVISION'
export const UPDATE_AREA = 'UPDATE_AREA'